import React from 'react';
import { X } from 'lucide-react';
import { formatCurrency } from '@/lib/commonConvert';

interface AmountModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
  amount: string;
  setAmount: (value: string) => void;
}

const AmountModal: React.FC<AmountModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  amount,
  setAmount,
}) => {
  const handleAmountInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/[^0-9]/g, '');
    setAmount(value);
  };

  const handleClose = () => {
    onClose();
    setAmount('');
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 !bg-black/50 flex items-center justify-center z-50">
      <div className="!bg-white dark:!bg-gray-800 rounded-md p-6 w-full max-w-md mx-4 shadow-xl">
        <div className="flex items-start justify-between mb-6">
          <h3 className="!text-lg !font-semibold !text-gray-900 dark:!text-white">
            Nhập số tiền cần rút
          </h3>
          <button
            onClick={handleClose}
            className="!bg-transparent !border-none !text-gray-400 hover:!text-gray-600 dark:hover:!text-gray-300 !p-1"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="mb-6">
          <input
            type="text"
            placeholder="Số tiền: 1.000.000 đ"
            value={amount ? `${formatCurrency(parseInt(amount), 'đ')}` : ''}
            onChange={handleAmountInputChange}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                onSubmit();
              }
            }}
            className="w-full !px-4 !py-3 !border !border-gray-300 dark:!border-gray-600 rounded-md !bg-white dark:!bg-gray-700 !text-gray-900 dark:!text-white !text-lg placeholder:!text-gray-400 focus:!outline-none focus:!ring-2 focus:!ring-blue-500"
          />
          <p className="!text-sm !text-blue-600 dark:!text-blue-400 mt-2">
            Vui lòng kiểm tra đúng số tiền cần rút
          </p>
        </div>

        <div className="flex gap-3">
          <button
            onClick={handleClose}
            className="flex-1 !px-4 !py-2.5 !border !border-gray-300 dark:!border-gray-600 rounded-md !text-gray-700 dark:!text-gray-300 hover:!bg-gray-50 dark:hover:!bg-gray-700 !transition-colors !bg-white dark:!bg-gray-800 !font-medium"
          >
            Hủy
          </button>
          <button
            onClick={onSubmit}
            className="flex-1 !px-4 !py-2.5 !bg-primary !text-white rounded-md hover:!bg-yellow-600 !transition-colors !border-none !font-medium"
          >
            Xác nhận
          </button>
        </div>
      </div>
    </div>
  );
};

export default AmountModal;
